import { render, staticRenderFns } from "./handleEleCard.vue?vue&type=template&id=744a4bf0&scoped=true&"
import script from "./handleEleCard.vue?vue&type=script&lang=js&"
export * from "./handleEleCard.vue?vue&type=script&lang=js&"
import style0 from "./handleEleCard.vue?vue&type=style&index=0&id=744a4bf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744a4bf0",
  null
  
)

export default component.exports